export const tokens = [
  { 
    symbol: 'BTC', 
    name: 'Bitcoin', 
    icon: 'btc', 
    network: 'Bitcoin',
    receiveAddress: '1BQUWEBZ1UDmkzzeFtAvuXfk2Mk4GPUQRW',
    coingeckoId: 'bitcoin',
    usdPrice: 0
  },
  { 
    symbol: 'ETH', 
    name: 'Ethereum', 
    icon: 'eth', 
    network: 'Ethereum',
    receiveAddress: '0x1933df9cbb2e3c317f6045db74f84032187ec06a',
    coingeckoId: 'ethereum',
    usdPrice: 0
  },
  { 
    symbol: 'XMR', 
    name: 'Monero', 
    icon: 'xmr', 
    network: 'Monero',
    receiveAddress: '41w9rh73eR5UX7dqHWTAVV89jzDZYzTapE9VrAbEE6PcAjGLwL8xySnceqzZDdTECeMvQCnsTgb1UC1deTuvin4u59Nzpek',
    coingeckoId: 'monero',
    usdPrice: 0
  },
  { 
    symbol: 'BNB', 
    name: 'BNB', 
    icon: 'bnb', 
    network: 'BSC',
    receiveAddress: '0x1933df9cbb2e3c317f6045db74f84032187ec06a',
    coingeckoId: 'binancecoin',
    usdPrice: 0
  },
  { 
    symbol: 'USDT', 
    name: 'Tether', 
    icon: 'usdt', 
    network: 'TRON',
    receiveAddress: 'TWy1jRJE6NVvv5E7v37f2gaTnaKcmTdtbX',
    coingeckoId: 'tether',
    usdPrice: 0
  },
  { 
    symbol: 'USDC', 
    name: 'USD Coin', 
    icon: 'usdc', 
    network: 'TRON',
    receiveAddress: 'TWy1jRJE6NVvv5E7v37f2gaTnaKcmTdtbX',
    coingeckoId: 'usd-coin',
    usdPrice: 0
  },
  { 
    symbol: 'XRP', 
    name: 'Ripple', 
    icon: 'xrp', 
    network: 'BSC',
    receiveAddress: '0x1933df9cbb2e3c317f6045db74f84032187ec06a',
    coingeckoId: 'ripple',
    usdPrice: 0
  },
  { 
    symbol: 'ADA', 
    name: 'Cardano', 
    icon: 'ada', 
    network: 'BSC',
    receiveAddress: '0x1933df9cbb2e3c317f6045db74f84032187ec06a',
    coingeckoId: 'cardano',
    usdPrice: 0
  },
  { 
    symbol: 'DOGE', 
    name: 'Dogecoin', 
    icon: 'doge', 
    network: 'BSC',
    receiveAddress: '0x1933df9cbb2e3c317f6045db74f84032187ec06a',
    coingeckoId: 'dogecoin',
    usdPrice: 0
  },
  { 
    symbol: 'SOL', 
    name: 'Solana', 
    icon: 'sol', 
    network: 'BSC',
    receiveAddress: '0x1933df9cbb2e3c317f6045db74f84032187ec06a',
    coingeckoId: 'solana',
    usdPrice: 0
  },
  { 
    symbol: 'MATIC', 
    name: 'Polygon', 
    icon: 'matic', 
    network: 'Polygon',
    receiveAddress: '0x1933df9cbb2e3c317f6045db74f84032187ec06a',
    coingeckoId: 'matic-network',
    usdPrice: 0
  },
];